import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-top: 12px;
`

export const DocumentsContainer = styled.section``

export const Title = styled.h2`
  text-transform: uppercase;
  font-size: ${({ theme }) => theme.font.sizes.medium};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 24px;
`

export const PendencySelection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

export const DirectorObservations = styled.div`
  margin-top: 48px;

  textarea {
    height: 160px;
  }
`

export const PendencyJustification = styled.div`
  margin-top: 80px;

  textarea {
    height: 160px;
  }
`

export const ActionsButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 48px;

  button {
    background-color: ${({ theme }) => theme.colors.mainBg};
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    justify-content: center;
  }
`
